export default __webpack_public_path__ + "static/media/fivest.6e262d04.png";